import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMember } from "../provider";
import FormCar from "./FormCar";
import ModalBox from "../../../ui/ModalBox";

const Update = () => {
  const [open, setOpen] = useState(false);
  const { id, mid } = useParams();
  const navigate = useNavigate();

  const [Car, setCar] = useState();
  const {
    state: { listCars, selected: member },
    fetchListCars,
    fetchOne: fetchMember,
  } = useMember();
  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };
  const handleSuccess = () => {
    setOpen(true);
  };
  useEffect(() => {
    fetchListCars(mid);
    fetchMember(mid);
  }, [mid]);

  useEffect(() => {
    const foundCar = listCars?.find((car) => car.id == id);
    setCar(foundCar);
  }, [id, listCars]);

  if (!Car) return;

  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom>
        Edit Car
      </Typography>
      <FormCar handleSuccess={handleSuccess} Car={Car} />
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The update operation has been completed successfully.. You update"
        name="Car"
      />
    </>
  );
};

export default Update;
